import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {createGlobalStyle} from 'styled-components';

import {addPrefix} from '@shared/lib/type_utils';

import {CssReset} from '@shared-web/components/core/css_reset';
import {GlobalStyle} from '@shared-web/components/core/global_styles';
import {ThemeContext} from '@shared-web/theme/theme_context';

import {App} from '@src/app';
import {theme} from '@src/theme';

const CustomCssReset = createGlobalStyle`
  #root {
    height: 100%;
  }
`;

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <ThemeContext.Provider value={theme}>
        <CssReset />
        <CustomCssReset />
        <App />
        <GlobalStyle {...addPrefix(theme.main, '$')} />
      </ThemeContext.Provider>
    </StrictMode>
  );
}
